import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import FrequencyPicker from './components/FrequencyPicker';
import {
  validateAddressForNotLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const clubSignup = {
      creditCard: data.creditCard,
      billTo: data.address,
      clubId: props.club.id
    };
    if (props.club.type === 'Subscription') {
      clubSignup.subscription = data.subscription;
    }
    const successFunction = () => {
      props.onEdit('account');
    };
    props.updateClubSignup(clubSignup, successFunction);
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  render() {
    const { club, clubSignup, handleSubmit, change, form, settings } =
      this.props;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (clubSignup.billTo) {
      object = clubSignup.billTo;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardForm />

        {club.type === 'Subscription' && (
          <>
            <h3>Subscription</h3>
            <FrequencyPicker />
          </>
        )}

        <h3>Billing address</h3>
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to account information
          </button>
          <a onClick={this.handleBack}>Return to customer information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let subscription;
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  const creditCard = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName
  };
  if (props.club.type === 'Subscription') {
    subscription = {
      frequency: integerFormat(values.frequency)
    };
  }
  return { address, creditCard, subscription };
};

const validate = (values, props) => {
  let errors = {};
  const { address } = transformData(values, props);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForNotLoggedInCustomer(address, props.settings)
  );
  const { creditCard } = transformData(values, props);
  errors = Object.assign(errors, validateCreditCard(creditCard));
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const clubSignup = state.clubSignup.data;
  let initialValues = {};
  if (clubSignup) {
    const { billTo } = clubSignup;
    initialValues = Object.assign(initialValues, initialFormValues(billTo));
    if (clubSignup.club.type === 'Subscription') {
      initialValues.frequency = clubSignup.subscription.frequency;
    }
  }
  if (!initialValues.countryCode) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    clubSignup: state.clubSignup,
    club: getClubBySlug(state.club, ownProps.match.params.slug),
    customer: state.customer,
    settings: state.setting,
    initialValues
  };
};

Payment = reduxForm({
  form: 'paymentNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, { updateClubSignup })(Payment)
);
